import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: ${Spacings.SPACING_3B};
  padding: 2px ${Spacings.SPACING_2B};
  border-radius: 4px;
  font-size: 10px;
  font-weight: ${Fonts.HEAVY};
  line-height: 12px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
`;

const OnlineTag = styled(Tag)`
  background-color: var(--color-i-green-10);
  color: var(--color-i-green-4);
`;

const OfflineTag = styled(Tag)`
  background-color: var(--color-i-blue-48);
  color: var(--color-i-blue-4);
`;

const CbtModeTag = ({ isOffline }) =>
  isOffline ? <OfflineTag>Offline</OfflineTag> : <OnlineTag>Online</OnlineTag>;

export default CbtModeTag;
